import { LinkMultiValuedList } from '../../../Link'
import { ListCell } from '../ListCell'

function TablePhoneListCell({ List = LinkMultiValuedList, ...restProps }) {
  return <ListCell {...restProps} List={List} />
}

export default TablePhoneListCell
